<template>
  <v-layout row wrap>
    <v-flex xs12 style="display: flex; flex-direction: column">
      <v-card class="pa-2" style="flex: 1 1 auto; display: flex; flex-direction: column">
        <v-card-title class="pb-0">
          <span class="subheading mb-1">{{ $t('Pilot.Encryption.Configuration') }}</span>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                v-model="passphrase"
                :type="showPassphrase ? 'text' : 'password'"
                :label="$t('Pilot.Encryption.Passphrase')"
                :append-icon="showPassphrase ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassphrase = !showPassphrase"
              />
            </v-flex>
            <v-flex xs12 v-if="revealedPassphrase !== null">
              <v-alert :value="true" type="info" class="mt-2" dense dismissible @input="clearReveal">
                {{ revealedPassphrase }}
              </v-alert>
            </v-flex>
            <v-flex xs12 v-if="noPassphraseDefined">
              <v-alert :value="true" type="warning" class="mt-2" dense>
                {{ $t('Pilot.Encryption.NoPassphraseDefined') }}
              </v-alert>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn color="secondary" :disabled="isRevealDisabled" :loading="revealLoading" @click="revealPassphrase">
            {{ $t('Pilot.Encryption.Reveal') }}
          </v-btn>
          <v-btn color="primary" :disabled="!passphrase || saveLoading" :loading="saveLoading" @click="savePassphrase">
            {{ $t('Pilot.Encryption.Save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script lang="ts">
import { AloMission } from '@/models/alo/AloMission'
import { IEncryptionResponse } from '@/models/iris/encryption/IEncryptionResponse'
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  name: 'MissionDetailEncryption',
  props: {
    mission: {
      type: AloMission,
    },
  },
})
export default class MissionDetailEncryption extends Vue {
  mission!: AloMission

  passphrase = ''
  showPassphrase = false
  revealedPassphrase: string | null = null
  noPassphraseDefined = false
  revealTimer: number | null = null

  get revealLoading(): boolean {
    return this.$store.myGetters.encryptionRevealLoading
  }

  get saveLoading(): boolean {
    return this.$store.myGetters.encryptionSaveLoading
  }

  get isRevealDisabled(): boolean {
    return this.revealLoading || this.revealTimer !== null
  }

  revealPassphrase() {
    if (this.isRevealDisabled) return
    this.noPassphraseDefined = false
    this.$store.myActions
      .MISSION_IRIS_ENCRYPTION_GET_REQUEST(this.mission.misId!)
      .then((response: unknown) => {
        const result = response as IEncryptionResponse
        if (result && result.data) {
          this.revealedPassphrase = result.data
          this.revealTimer = window.setTimeout(() => {
            this.clearReveal()
          }, 10000)
        } else {
          this.noPassphraseDefined = true
        }
      })
      .catch(() => {
        // l'erreur est gérée par le store
      })
  }

  savePassphrase() {
    this.$store.myActions
      .MISSION_IRIS_ENCRYPTION_SAVE_REQUEST({ misId: this.mission.misId!, passphrase: this.passphrase })
      .then(() => {
        this.passphrase = ''
        this.showPassphrase = false
      })
      .catch(() => {
        // l'erreur est gérée par le store
      })
  }

  clearReveal() {
    if (this.revealTimer !== null) {
      clearTimeout(this.revealTimer)
    }
    this.revealedPassphrase = null
    this.revealTimer = null
  }

  beforeDestroy() {
    if (this.revealTimer !== null) {
      clearTimeout(this.revealTimer)
    }
  }
}
</script>
